import { type Query, useQuery } from '../graphql';
import { useTeam } from '../hooks/team';

export const getOwnerPortalTaxStatementSetting = (
  q: Query,
  args: {
    teamId: string;
    teamBillingAddressCountryCode?: string | null;
  }
) => {
  const isUSAAddress =
    args.teamBillingAddressCountryCode?.toUpperCase() === 'US';

  const hideTaxStatementSettingId = q.setting({
    where: {
      tenant_id: { _eq: args.teamId },
      key: { _eq: 'tenantSettings' },
      target: { _eq: 'hideTaxStatements' },
    },
    limit: 1,
  })[0]?.id as string | undefined;

  return !hideTaxStatementSettingId && isUSAAddress;
};

export function useOwnerPortalTaxStatementSettingQuery() {
  const [{ id: teamId, billingAddress: teamBillingAddress }] = useTeam();

  return useQuery(
    (q, args) => {
      return getOwnerPortalTaxStatementSetting(q, args);
    },
    {
      keepPreviousData: true,
      variables: {
        teamId,
        teamBillingAddressCountryCode: teamBillingAddress?.countryCode,
      },
    }
  );
}
